/**
 * StatusToast - Real-time notification component
 *
 * Displays real-time status updates and notifications using Socket.IO.
 * Shows payment status, system alerts, and other live updates.
 */
import { useSocket } from '../contexts/SocketContext';

function StatusToast() {
  const { notifications, clearNotification } = useSocket();
  console.log(`StatusToast is returning ${notifications.length} notifications`);

  if (!notifications || notifications.length === 0) {
    return null;
  }

  return (
    <div 
      className="status-toast-container"
      role="region"
      aria-label="Notifications"
      aria-live="polite"
    >
      {notifications.map((notification) => {
        const variant = notification.type || 'default';
        const variantClass = `status-toast-notification-${variant}`;
        const ariaRole = variant === 'error' ? 'alert' : 'status';
        const title = notification.type === 'error' ? 'Error' : notification.type === 'success' ? 'Success' : 'Notification';
        
        return (
          <div 
            key={notification.timestamp} 
            className={`status-toast-notification-base ${variantClass}`}
            role={ariaRole}
            aria-labelledby={`toast-title-${notification.timestamp}`}
            aria-describedby={`toast-desc-${notification.timestamp}`}
          >
            <div 
              id={`toast-title-${notification.timestamp}`}
              className="status-toast-title"
            >
              {title}
            </div>
            <div 
              id={`toast-desc-${notification.timestamp}`}
              className="status-toast-description"
            >
              {notification.message}
            </div>
            <button
              type="button"
              onClick={() => clearNotification(notification.timestamp)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  clearNotification(notification.timestamp);
                }
              }}
              className="status-toast-dismiss-button"
              aria-label={`Dismiss ${title}`}
            >
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default StatusToast;
